import { memo } from 'react';

import { Widget } from '@/components/ui/widget';
import { BoxSectionContext } from './box.context';
import { type WidgetData } from '@/components/ui/widget/widget.type';
import {
  type BoxSection,
  type BoxView
} from '@/components/ui/widget/views/box/box.view.type';

type BoxViewProps = {
  view: BoxView;
  data: WidgetData;
};

type BoxItemProps = {
  index: number;
  item: BoxSection;
  data: WidgetData;
};

export const BoxItem = memo(({ index, item, data }: BoxItemProps) => (
  <BoxSectionContext.Provider value={{ index }}>
    {/* @ts-expect-error should be fixed when Widget is typed */}
    <Widget widget={item} data={data} />
  </BoxSectionContext.Provider>
));

export const BoxViewImpl = memo(({ view, data }: BoxViewProps) => (
  <div className="flex flex-col">
    {view.sections &&
      view.sections.map((item, index) => (
        <BoxItem
          key={item.view?.title ?? index}
          index={index}
          item={item}
          data={data}
        />
      ))}
  </div>
));

export const boxViewProvider = {
  component: BoxViewImpl
};
